import { render, staticRenderFns } from "./Prosecution.vue?vue&type=template&id=30743227&scoped=true&"
import script from "./Prosecution.vue?vue&type=script&lang=js&"
export * from "./Prosecution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30743227",
  null
  
)

export default component.exports